module.exports = __webpack_public_path__ + "img/1448453998.ebc8d462.jpg";